import { applySwapperStyles } from "@src/config";
import { HistoryProvider, RewardsProvider, SwapProvider } from "@src/contexts";
import { Route, SwapperAppPayload } from "@src/models";
import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { PrivySmartWalletProvider } from "@src/contexts/PrivySmartWalletProvider";
import { MemoryRouter } from "react-router-dom";
import { AppRouter } from "@src/routes/AppRouter";
import { injectTooltipLayer } from "@src/utils";

export const SwapperApp = ({
  integratorId,
  integrationType,
  chainIds,
  dstChainId,
  dstTokenAddr,
  dstTokenImage,
  customContractCalls,
  externalWalletAddress,
  desc,
  supportedChains,
  isFetchingChains,
  defaultWalletPicker,
  development = false,
  cta,
  styles,
  isDirectOnRampSupported,
  isCheckingDirectOnRamp,
}: SwapperAppPayload &
  (
    | {
        onSubmit: (route: Route) => void;
        onClose: () => void;
        overlay: true;
      }
    | {
        // Satisfy TypeScript, so it understands that this field is not needed when overlay=false
        onSubmit?: undefined;
        onClose?: undefined;
        overlay: false;
      }
  )) => {
  useEffect(() => {
    applySwapperStyles(styles);
  }, [styles]);

  useEffect(() => {
    injectTooltipLayer();
  }, []);
  return (
    <ErrorBoundary
      FallbackComponent={() => (
        <div>Something went wrong, please contact Swapper.</div>
      )}
    >
      <MemoryRouter>
        <PrivySmartWalletProvider styles={styles} development={development}>
          <HistoryProvider chainIds={chainIds}>
            <RewardsProvider>
              <SwapProvider
                integrationConfig={{
                  integratorId,
                  integrationType,
                  chainIds,
                  dstChainId,
                  dstTokenAddr,
                  dstTokenImage,
                  customContractCalls,
                  externalWalletAddress,
                  desc,
                  defaultWalletPicker,
                  development,
                  cta,
                  styles,
                }}
                isDirectOnRampSupported={isDirectOnRampSupported ?? false}
                isCheckingDirectOnRamp={isCheckingDirectOnRamp ?? false}
                supportedChains={supportedChains}
                isFetchingChains={isFetchingChains}
              >
                <div
                  id="app-router-container"
                  className="relative bg-background_primary rounded-[16px] text-text_primary h-[560px] max-w-x_modal w-full"
                >
                  <AppRouter />
                </div>
              </SwapProvider>
            </RewardsProvider>
          </HistoryProvider>
        </PrivySmartWalletProvider>
      </MemoryRouter>
    </ErrorBoundary>
  );
};
